import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-productinformation',
  templateUrl: './productinformation.component.html',
  styleUrls: ['./productinformation.component.scss']
})
export class ProductinformationComponent implements OnInit {
  product: any[];
  recurringProduct: any;
  onceOffProduct: any;
  chk_even = '';
  isMonthActive: boolean;
  isDayActive: boolean;
  planOptions: any[] = [];
  selectedPlanDays: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { message: any, serviceProviderId: number },
    public dialogRef: MatDialogRef<ProductinformationComponent>
  ) {
    if (data) {
      console.log("Data in Productclass :", data);
      this.product = [data.message];
    }
  }

  ngOnInit() {
    debugger
    this.recurringProduct = this.product[0].filter(element => {
      return element.subCategoryId == 2;
    });
    this.onceOffProduct = this.product[0].filter(element => {
      return element.subCategoryId == 1;
    });
    if (this.data.serviceProviderId == 4 && this.data.message && this.data.message.length) {
      this.planOptions = this.data.message;
      // this.selectedPlanDays = this.planOptions[0].validityDays; // default select 3 days
    }
  }
  onCancel() {
    this.dialogRef.close();
  }

  productTypeChange(event) {
    this.chk_even = event.value;
    var check = [];
    check = this.product[0].filter(element => {
      return element.id == this.chk_even;
    });

    if (check[0].subCategoryId == '1') {
      this.isDayActive = true;
      this.isMonthActive = false;
    } else {
      this.isMonthActive = true;
      this.isDayActive = false;
    }
  }

  submit() {

    this.dialogRef.close(this.chk_even);

  }

  //   submit() {
  //   if (this.data.serviceProviderId === 4) {
  //     const selectedProduct = this.planOptions.find(
  //       p => p.validityDays === this.selectedPlanDays

  //     );

  //     if (selectedProduct) {
  //       console.log("Selected product:", selectedProduct);
  //       this.dialogRef.close(selectedProduct.id);  
  //     } else {
  //       console.warn("No matching product found for selected validity day");
  //     }

  //   } else {
  //     this.dialogRef.close(this.chk_even);
  //   }
  // }

}
